var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99199 1.66699C5.39199 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.39199 18.3337 9.99199 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 9.99199 1.66699ZM10.0003 16.667C6.31699 16.667 3.33366 13.6837 3.33366 10.0003C3.33366 6.31699 6.31699 3.33366 10.0003 3.33366C13.6837 3.33366 16.667 6.31699 16.667 10.0003C16.667 13.6837 13.6837 16.667 10.0003 16.667ZM10.417 5.83366H9.16699V10.8337L13.542 13.4587L14.167 12.4337L10.417 10.2087V5.83366Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessTime);
export default __webpack_public_path__ + "static/media/access_time.7ecf9dfd9792a33013d47710e2edb6c7.svg";
export { ForwardRef as ReactComponent };